import axiosSmartSurvey from "../../../api/axios"

export default function useMartra10() {
    // async function fetchMartra10Data(parcelNo, startDate, endDate, setM10Data) {
    //     if (parcelNo) {
    //         try {
    //             const response = await axiosSmartSurvey.post('/martra10/searchdata', { parcelNo: parcelNo, startDate: startDate, endDate: endDate })
    //             console.log(response)
    //             setM10Data(response.data.results)
    //         } catch (err) {
    //             console.log(err)
    //         }
    //     }
    // }
    async function fetchMartra10Data(parcelNo, startDate, endDate, setM10Data) {

        try {
            // อาจจะเพิ่ม setIsLoading(true) ตรงนี้ถ้ามี loading spinner
            const response = await axiosSmartSurvey.post('/martra10/searchdata', {
                parcelNo,
                startDate,
                endDate
            });

            if (response.data && response.data.results) {
                setM10Data(response.data.results);
                // console.log(response.data.results)
            }
        } catch (err) {
            console.error("Fetch Error:", err);

            // ถ้า API ส่ง 404 มา (หาไม่เจอ) ให้เคลียร์ข้อมูลหน้าจอ
            if (err.response && err.response.status === 404) {
                setM10Data([]);
                // alert("ไม่พบข้อมูลที่ระบุ");
            } else {
                // กรณี error อื่นๆ เช่น Server ล่ม
                alert("เกิดข้อผิดพลาดในการดึงข้อมูล");
            }
        } finally {
            // setIsLoading(false) ถ้ามี loading spinner
        }
    }
    return { fetchMartra10Data }
}
